import VehiclesGroupedReport from "./VehiclesGroupedReport";

export default function VehiclesByCity() {
  return (
    <VehiclesGroupedReport
      title="Vehicles by City"
      subtitle="Active fuel access registrations grouped by the city of the user's retail outlet."
      dimension="city"
      dropdownLabel="City"
      dropdownPlaceholder="All cities"
      dropdownApiPath="/master/cities"
    />
  );
}
